import { useMedia } from 'react-use';

export const useIsPWA = () => {
  return useMedia('(display-mode: standalone)');
};
